import { useTranslation } from 'react-i18next';

import { IResendEmailVerificationLinkForm } from 'authOld/types';
import { Field, Form } from 'coreOld/components';
import { InputType, Size } from 'coreOld/enums';
import { getRequiredLabel } from 'coreOld/utils';

import { resendEmailVerificationLinkSchema } from './resendEmailVerificationLinkFormSchema';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => (data: IResendEmailVerificationLinkForm) => void;
  isSubmitted?: boolean;
  goBack: () => void;
}

const ResendEmailVerificationLinkFormView = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitted,
  goBack,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Form<IResendEmailVerificationLinkForm>
      isOpen={isOpen}
      onClose={onClose}
      title={t('titleResendEmailVerificationLink')}
      submitBtnLabel={isSubmitted ? undefined : t('buttonLabelResend')}
      defaultValues={{ email: '' }}
      onSubmit={onSubmit}
      schema={resendEmailVerificationLinkSchema()}
      hasGoBack
      goBack={goBack}
    >
      {!isSubmitted && (
        <Field
          name="email"
          label={getRequiredLabel(t('labelEmailAddress'))}
          type={InputType.TEXTFIELD}
          inputProps={{
            size: Size.LG,
            autoFcous: true,
          }}
        />
      )}
    </Form>
  );
};

export default ResendEmailVerificationLinkFormView;
